module.exports = __webpack_public_path__ + "img/box 1.e1451198.svg";